import type { Rol, UsuarioActualizarInput, UsuarioCrearInput, UsuarioPublic } from '@app/shared';

import { api } from '../../../lib/api';

interface ListResponse {
  total: number;
  usuarios: UsuarioPublic[];
}

export interface UsuarioLookup {
  id: string;
  nombre: string;
  email: string;
  rol: Rol;
}

export const usuariosApi = {
  // Slice 3.5 — Lookup minimal accesible para cualquier autenticado.
  async lookup(params: { rol?: Rol | Rol[]; activo?: boolean; limit?: number } = {}): Promise<{
    usuarios: UsuarioLookup[];
  }> {
    const { data } = await api.get<{ usuarios: UsuarioLookup[] }>('/usuarios/lookup', { params });
    return data;
  },

  async list(params: {
    skip?: number;
    take?: number;
    rol?: string;
    activo?: boolean;
  }): Promise<ListResponse> {
    const { data } = await api.get<ListResponse>('/usuarios', { params });
    return data;
  },

  async create(input: UsuarioCrearInput): Promise<{ usuario: UsuarioPublic; passwordTemporal?: string }> {
    const { data } = await api.post<{ usuario: UsuarioPublic; passwordTemporal?: string }>(
      '/usuarios',
      input,
    );
    return data;
  },

  async update(id: string, input: UsuarioActualizarInput): Promise<{ usuario: UsuarioPublic }> {
    const { data } = await api.patch<{ usuario: UsuarioPublic }>(`/usuarios/${id}`, input);
    return data;
  },

  async resetPassword(id: string): Promise<{ passwordTemporal: string }> {
    const { data } = await api.post<{ passwordTemporal: string }>(`/usuarios/${id}/reset-password`);
    return data;
  },
};
